import React from 'react'
import 'react-device-emulator/lib/styles/style.css'
import BottomBar from '../BottomBar'
import { heightPercentageToDP } from '../../Utils/ResponsiveScreen'
import './PlayIcon.css'
class VideoPreview extends React.Component {
	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		const { data, type } = this.props
		return (
			<div
				style={{
					position: 'relative',
					height: heightPercentageToDP('100%'),
				}}
			>
				{data && data.videoMetaInfo ? (
					data.videoMetaInfo.thumbnail ? (
						<div className='videoData'>
							<img
								src={data.videoMetaInfo.thumbnail}
								alt='Video Thumbnail'
								style={{ width: '100%', height: '100%' }}
							/>

							<div>
								<a href='#' className='playWrapper'>
									<span className='playBtn'>
										<img src='Images/index.png' width='60' height='60' alt='PlayIcon' />
									</span>
								</a>
							</div>
						</div>
					) : null
				) : null}

				<BottomBar
					data={this.props.data}
					selectedContributor={this.props.selectedContributor}
					createAs={this.props.createAs}
					type={type}
				/>
			</div>
		)
	}
}

export default VideoPreview
